import { render } from "./EditTypeUser.vue?vue&type=template&id=3727ba4c&scoped=true"
import script from "./EditTypeUser.vue?vue&type=script&lang=js"
export * from "./EditTypeUser.vue?vue&type=script&lang=js"

import "./EditTypeUser.vue?vue&type=style&index=0&id=3727ba4c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3727ba4c"]])

export default __exports__